export default {
      id: "command__delete-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#command__delete",
      toString: function () {
        return this.url;
      }
    }